import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const RulesPopup = ({ isOpen, onClose, bonusTitle, rules = [] }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return (
    <div className="rules-popup-overlay">
      <div className="rules-popup">
        <div className="rules-popup-header">
          <h3>{bonusTitle}</h3>
          <button 
            className="close-button"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        
        <div className="rules-popup-content">
          <h4 className="rules-popup-subtitle">{t('popup.rulesTitle', 'Kurallar ve Koşullar')}</h4>
          
          <div className="rules-list">
            {rules && rules.length > 0 ? (
              rules.map((rule, index) => (
                <div key={index} className="rule-item">
                  <div className="rule-number">{index + 1}</div>
                  <div className="rule-content">
                    <h5 className="rule-title">{rule.title}</h5>
                    <p className="rule-text">
                      {rule.metin.split('\n').map((textPart, i) => (
                        <React.Fragment key={i}>
                          {textPart}
                          {i < rule.metin.split('\n').length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-rules">
                <p>{t('popup.noRules', 'Bu bonus için henüz kural belirtilmemiştir.')}</p>
              </div>
            )}
          </div>
        </div>
        
        <div className="rules-popup-footer">
          <button className="rules-close-button" onClick={onClose}>
            {t('buttons.close', 'Kapat')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesPopup; 